import { useTranslation } from "react-i18next";

export default function WhatIs() {
  const { t } = useTranslation();

  return (
    <section id="what-is" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-start">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-file-list-3-line"></i>
              {t("nav.spreadsheet")}
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t("whatIs.title")}
            </h2>
          </div>
          <div className="space-y-4">
            <p className="text-base leading-relaxed text-foreground-700">
              {t("whatIs.p1")}
            </p>
            <p className="text-base leading-relaxed text-foreground-700">
              {t("whatIs.p2")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}